import React, { useState, useEffect } from "react";

import Form from "react-bootstrap/Form";

import ImageUploader from "../../imageuploader";

import { apiDelete, apiGet, apiPost, apiPut } from "../../../api/server"

const EventRow = (props) => {

   const [image1, setImage1] = useState("https://business-butler-media.s3.eu-west-2.amazonaws.com/email-images/placeholder.png")
   const [imageOptions, setImageOptions] = useState([])

    function refreshImageOptions(){
        console.log("hello")
        setImageOptions([])
        apiGet(`intranetfileupload/geteventemailimages`).then(res => {
            res.json().then(data => {
                
                setImageOptions(data)
            })
        })
    }

   

   useEffect(() => {
    apiGet(`intranetfileupload/geteventemailimages`).then(res => {
        res.json().then(data => {
            
          setImageOptions(data)
        })
      })

      props.updateComponentHTML(props.id, 
        `<table align="center" border="0" cellpadding="0" cellspacing="0" class="row row-4" role="presentation" style="mso-table-lspace: 0pt; mso-table-rspace: 0pt;" width="100%">
        <tbody>
            <tr>
                <td>
                    <table align="center" border="0" cellpadding="0" cellspacing="0" class="row-content stack" role="presentation" style="mso-table-lspace: 0pt; mso-table-rspace: 0pt; color: #000000; width: 600px;" width="600">
                        <tbody>
                            <tr>
                                <td class="column column-1" style="mso-table-lspace: 0pt; mso-table-rspace: 0pt; font-weight: 400; text-align: left; vertical-align: top; border-top: 0px; border-right: 0px; border-bottom: 0px; border-left: 0px;" width="100%">
                                    <table border="0" cellpadding="0" cellspacing="0" class="image_block block-2" role="presentation" style="mso-table-lspace: 0pt; mso-table-rspace: 0pt;" width="100%">
                                        <tr>
                                            <td class="pad" style="width:100%;padding-right:0px;padding-left:0px;padding-top:20px;">
                                                <div align="center" class="alignment" style="line-height:10px"><img  src="${image1}" style="display: block; height: auto; border: 0; width: 400px; max-width: 100%;"  width="400"/></div>
                                            </td>
                                        </tr>
                                    </table>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </td>
            </tr>
        </tbody>
    </table>`)
   }, [])

   useEffect(() => {
      props.updateComponentHTML(props.id,
         `<table align="center" border="0" cellpadding="0" cellspacing="0" class="row row-4" role="presentation" style="mso-table-lspace: 0pt; mso-table-rspace: 0pt;" width="100%">
         <tbody>
             <tr>
                 <td>
                     <table align="center" border="0" cellpadding="0" cellspacing="0" class="row-content stack" role="presentation" style="mso-table-lspace: 0pt; mso-table-rspace: 0pt; color: #000000; width: 600px;" width="600">
                         <tbody>
                             <tr>
                                 <td class="column column-1" style="mso-table-lspace: 0pt; mso-table-rspace: 0pt; font-weight: 400; text-align: left; vertical-align: top; border-top: 0px; border-right: 0px; border-bottom: 0px; border-left: 0px;" width="100%">
                                     <table border="0" cellpadding="0" cellspacing="0" class="image_block block-2" role="presentation" style="mso-table-lspace: 0pt; mso-table-rspace: 0pt;" width="100%">
                                         <tr>
                                             <td class="pad" style="width:100%;padding-right:0px;padding-left:0px;padding-top:20px;padding-bottom:20px;">
                                                 <div align="center" class="alignment" style="line-height:10px"><img  src="${image1}" style="display: block; height: auto; border: 0; width: 400px; max-width: 100%;"  width="400"/></div>
                                             </td>
                                         </tr>
                                     </table>
                                 </td>
                             </tr>
                         </tbody>
                     </table>
                 </td>
             </tr>
         </tbody>
     </table>`)
   }, [image1,])

   return (
      <>
      <h4>Centred Image</h4>
      <ImageUploader dirname="events-email" width={1200} height={628} setImageLocation={() => refreshImageOptions()} />
      <Form.Group controlId="update.Image1">
        <Form.Label>Image</Form.Label>
            <Form.Control onChange={(event) => setImage1(event.target.value)} as="select" value={image1} >
            {imageOptions.map(item => {
                const shortitem = item.substring(item.lastIndexOf("/") + 1)
                if(shortitem){
                    return <option value={item}>{shortitem}</option>
                }
                else{
                    return(<option value={"https://business-butler-media.s3.eu-west-2.amazonaws.com/email-images/placeholder.png"}>Choose an image:-</option>)
                }

                
            })}
            </Form.Control>
      </Form.Group>

      
      </>
   )
}

export default EventRow;